// extracted by mini-css-extract-plugin
export default {"cardsHolder":"CardsShop_cardsHolder__moEwS","section":"CardsShop_section__ggTpK"};